import styled from "styled-components";

export const styles = {
  title: {
    margin: "15px 0 20px",
    fontWeight: 700,
    color: "#39b54a",
    fontSize: 24,
    borderBottom: "1px solid #8da3aa",
    paddingBottom: 15,
  },
  icon: {
    color: "#39b54a",
  },
  iconsList: {
    padding: 0,
  },
  icons: {
    paddingRight: 10,
  },
  description: {
    fontSize: 14,
    color: "#8290a2",
    lineHeight: 1.5,
    width: "100%",
    overflowWrap: "break-word",
  },
  container: {
    paddingTop: 20,
  },
  sidebar: {
    container: {
      border: "1px solid #dfe1e4",
      borderRadius: 5,
      padding: 20,
      marginBottom: 20,
    },
    profileThumb: {
      padding: 20,
      margin: "auto",
      textAlign: "center",
    },
    haveJobBlock: {
      textAlign: "center",
    },
    img: {
      width: "100%",
      border: "6px solid #f5f5f5",
      objectFit: "cover",
    },
  },
};

export const ApplyNow = styled.button`
  font-size: 1.7rem;
  padding: 0.7em 1em;
  margin: 1em 0;

  @media (max-width: 1000px) {
    position: sticky;
    bottom: 100px;
    width: 100%;
  }
`;

export const Description = styled.div`
  position: relative;
`;
